<template>
  <div class="containter">
    <navTop class="navTop navFixed" :topFixed="true" :topIndex="topIndex" :childrenIndex="childrenIndex" />
    <banner :bannerObj="bannerObj" @dialogVisible="getChild" />
    <p class="monitor-content">利用人脸识别、人体识别等行业领先的计算机视觉技术，帮助线下零售业态全方位搜集客户数据生成全面细致的业务分析报表，辅助决策者洞察客户的行为特征，理解业务的本质和趋势，为准确高效的决策提供依据</p>
    <product-content
      :productContentArr = product
    />
    <footer-a />
    <back-top />
    <dialog-business :dialogVisible="dialogVisible" @dialogVisible="closeFn"/>
  </div>
</template>

<script>
import navTop from '../components/nav'
import banner from '../components/banner'
import productContent from '../components/productContent'
import footerA from '../components/footer'
import backTop from '../components/backTop'
import dialogBusiness from '../components/dialogBusiness'
import i1 from '../assets/images/monitor/1.png'
import i2 from '../assets/images/monitor/2.png'
import i3 from '../assets/images/monitor/3.png'
import i4 from '../assets/images/monitor/4.png'
import i5 from '../assets/images/monitor/5.png'
export default {
  data () {
    return {
      product: [
        {img: i1, content: '区别于红外感应探头，能自动区分顾客进场、出场、多次进出获取最真实的客流数据', boxStyle: 'padding-left: 0.3rem;', label: '数据真实，自动去重', type: 'left', style: 'width: 1.77rem;padding-left: 0.5rem;'},
        {img: i2, content: '通过人脸AI识别技术，锁定会员身份，自动匹配数据库区 分生客/熟客，并关联顾客行为数据，可与业务系统打通， 进一步完善用户画像', boxStyle: '', label: '精准识别，生客/熟客', type: 'right', style: 'width: 1.77rem;padding-right: 0.8rem;'},
        {img: i3, content: '根据客户在场内的行动轨迹，生成现场实时热力图，指导店面区域划分，产品摆放', boxStyle: 'padding-left: 0.3rem;', label: '客户动线，热力分析', type: 'left', style: 'width: 1.77rem;padding-left: 0.5rem;'},
        {img: i4, content: '可针对黑白名单设计，达到群体/个体识别、提醒、消息推送', boxStyle: '', label: '智能安防，异常预警', type: 'right', style: 'width: 1.77rem;padding-right: 0.6rem;'}
      ],
      bannerObj: {
        img: i5,
        title: '客流监控',
        content: '全方位重构“人、货、场”三要素，监控、分析、预警',
        button: '业务咨询'
      },
      topIndex: 1,
      childrenIndex: 5,
      dialogVisible: false
    }
  },
  components: {
    navTop,
    banner,
    productContent,
    backTop,
    dialogBusiness,
    footerA
  },
  methods: {
    getChild (v) {
      this.dialogVisible = v
    },
    closeFn (v) {
      this.dialogVisible = v
    }
  }
}
</script>

<style scoped>
.monitor-content{
  width: 1040px;
  margin: 110px auto 60px;
  font-size:20px;
  font-family:PingFang SC;
  font-weight:500;
  line-height:35px;
  color:rgba(102,102,102,1);
}

</style>



// WEBPACK FOOTER //
// src/view/monitor.vue